export default __webpack_public_path__ + "static/media/Clinic_Dir_Bio_Jesse_Pooler_Tacoma_05292025.337fbfec.pdf";